module.exports = __webpack_public_path__ + "static/img/activity-scene-5.e68b264.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/activity-scene-5.jpg
// module id = JhRJ
// module chunks = 10